import { render, staticRenderFns } from "./AddFood.vue?vue&type=template&id=1c7eb652&"
import script from "./AddFood.vue?vue&type=script&lang=js&"
export * from "./AddFood.vue?vue&type=script&lang=js&"
import style0 from "./AddFood.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports